var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Writing" }, [
    !_vm.data.answered
      ? _c("div", [
          _c("div", { staticClass: "question" }, [
            _c("div", { staticClass: "title" }, [
              _c("strong", { staticClass: "bold" }, [
                (_vm.data.rule
                ? _vm.data.rule.isNecessary
                  ? 1
                  : 0
                : 0)
                  ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                  : _vm._e(),
                _vm._v(_vm._s(_vm.data.questionTitle))
              ]),
              _vm._v(" "),
              (_vm.data.rule
              ? _vm.data.rule.subTitle
              : false)
                ? _c("span", { staticClass: "span" }, [
                    _vm._v(_vm._s(_vm.data.rule.subTitle))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.data.questionDes
              ? _c("pre", [
                  _vm._v(_vm._s(JSON.parse(_vm.data.questionDes)[0].txt))
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.$i18n.locale === "en"
            ? _c(
                "div",
                { staticClass: "btn bold cursor", on: { click: _vm.toPage } },
                [_vm._v("Enter Test")]
              )
            : _c(
                "div",
                { staticClass: "btn bold cursor", on: { click: _vm.toPage } },
                [_vm._v("进入写作")]
              )
        ])
      : _c("div", [
          _c("div", { staticClass: "question" }, [
            _c("div", { staticClass: "title" }, [
              _c("strong", { staticClass: "bold" }, [
                (_vm.data.rule
                ? _vm.data.rule.isNecessary
                  ? 1
                  : 0
                : 0)
                  ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                  : _vm._e(),
                _vm._v(_vm._s(_vm.data.questionTitle))
              ]),
              _vm._v(" "),
              (_vm.data.rule
              ? _vm.data.rule.subTitle
              : false)
                ? _c("span", { staticClass: "span" }, [
                    _vm._v(_vm._s(_vm.data.rule.subTitle))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.data.questionDes
              ? _c("pre", [
                  _vm._v(_vm._s(JSON.parse(_vm.data.questionDes)[0].txt))
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "answer_btn cursor",
                on: { click: _vm.answerBtn }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "answer_btn_title ellipsis",
                    attrs: { title: JSON.parse(_vm.data.answered).title }
                  },
                  [_vm._v(_vm._s(JSON.parse(_vm.data.answered).title))]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "answer_btn_icon blpc" }, [
                  _vm._v("")
                ])
              ]
            )
          ])
        ]),
    _vm._v(" "),
    _c("div", { staticClass: "answerObj none" }, [
      _vm._v(_vm._s(_vm.answerObj))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "isNecessary none" }, [
      _vm._v(_vm._s(_vm.data.rule ? (_vm.data.rule.isNecessary ? 1 : 0) : 0))
    ]),
    _vm._v(" "),
    _vm.data.rule.cameraMandatory === 1 && !_vm.data.answered
      ? _c(
          "div",
          { staticClass: "dpn" },
          [
            _c("Video", {
              ref: "videocontent",
              attrs: { isNeedShoot: false },
              on: { canGo: _vm.dealBtn }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-0af53477", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0af53477","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/module/topic/public/writing-box.vue
// module id = null
// module chunks = 